/*global $*/
/*eslint no-undef: "error"*/
export default class TabProduct {
    classButton = 'tab-product--button'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            let block = 'product-block-' + $(this).data('block')

            if ($(`#${block}`).length > 0) {
                $('html,body').stop().animate(
                    {
                        scrollTop: $(`#${block}`).offset().top
                    },
                    500
                )
            }
        })
    }
}
